/* ============================================================================
   SLURPPED — "Make it a regular thing" fold around Seal's purchase options
   ----------------------------------------------------------------------------
   Ruled by Ollie 11 Sep 2026: the subscription choice sits behind a quiet
   <details> fold, closed by default (closed = one-off, Seal's own default).
   THE ONE RULE THAT MATTERS: a recurring choice is never hidden once made.
   When a selling plan is picked the fold OPENS, stays open (a close is undone),
   and its summary line states the terms — "Every week, £21.60 a box" — so even
   a shut fold would still say it. Nothing here touches what posts: Seal's own
   inputs live inside the fold and submit exactly as before.
   Used by the buy zone, the egg band and the top-up cards; one copy of the
   logic. The buy zone's refreshMode() also calls update() so the two agree.
   ========================================================================== */
(function (w, d) {
  'use strict';
  if (w.SlurppedSubfold) return;

  function money(p) { var n = Number(p); return isFinite(n) ? '£' + (n / 100).toFixed(2) : ''; }
  function cadence(name) {
    var n = String(name || '').toLowerCase();
    var wk = n.match(/(\d+)\s*week/);
    if (wk) return wk[1] === '1' ? 'Every week' : 'Every ' + wk[1] + ' weeks';
    if (n.indexOf('month') > -1) return 'Every month';
    return String(name || '').trim();
  }
  function plansOf(fold) {
    try { return JSON.parse(fold.getAttribute('data-plans') || '[]') || []; } catch (e) { return []; }
  }
  function pickedPlan(fold) {
    var form = fold.closest('form');
    var el = form && form.elements['selling_plan'];
    var id = el && el.value ? String(el.value) : '';
    if (!id) return null;
    var plans = plansOf(fold);
    for (var i = 0; i < plans.length; i++) if (String(plans[i].id) === id) return plans[i];
    return { id: id, name: '', price: null };
  }
  function update(fold) {
    var plan = pickedPlan(fold);
    var state = fold.querySelector('[data-sub-fold-state]');
    var unit = fold.getAttribute('data-unit') || 'a box';
    if (plan) {
      fold.classList.add('is-sub');
      fold.open = true;
      if (state) state.textContent = (cadence(plan.name) || 'Regular') + (plan.price != null ? ', ' + money(plan.price) + ' ' + unit : '');
    } else {
      fold.classList.remove('is-sub');
      if (state) state.textContent = '';
    }
  }
  function all() { return d.querySelectorAll('[data-sub-fold]'); }
  function updateAll() { var f = all(); for (var i = 0; i < f.length; i++) update(f[i]); }

  // Seal announces plan changes; its radios also bubble a change event.
  d.addEventListener('sealsubs:selling_plan_changed', updateAll);
  d.addEventListener('sealsubs:subscription_widget_created', updateAll);
  d.addEventListener('change', function (e) {
    var fold = e.target && e.target.closest ? e.target.closest('[data-sub-fold]') : null;
    if (fold) update(fold);
  });
  // A subscribing fold cannot be shut: undo the close and keep the terms in view.
  d.addEventListener('toggle', function (e) {
    var fold = e.target;
    if (fold && fold.matches && fold.matches('[data-sub-fold]') && !fold.open && fold.classList.contains('is-sub')) fold.open = true;
  }, true);
  // Seal renders after load; watch each fold's widget so the initial state is right.
  function watch() {
    var f = all();
    for (var i = 0; i < f.length; i++) {
      var target = f[i].querySelector('.sealsubs-target-element');
      if (target && 'MutationObserver' in w && !target.__subfoldWatched) {
        target.__subfoldWatched = true;
        new MutationObserver(function (fold) { return function () { update(fold); }; }(f[i])).observe(target, { subtree: true, childList: true, attributes: true });
      }
      update(f[i]);
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', watch); else watch();

  w.SlurppedSubfold = { update: update, updateAll: updateAll, watch: watch };
})(window, document);
